import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    links: [],
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc',
    dialog: false,
    campaign: {
      name:'',
      id: null,
      url: '',
      source: null,
      medium: null
    }
  },

  mutations: {
    setLinks(state, payload) {
      state.links = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    }
  },

  actions: {
    read({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/campaign-links', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type
          }
        })
        .then(r => {
          commit('setLinks', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    delete({ dispatch }, id) {
      axios.admin.delete('cms/campaign-links/remove/' + id).then(() => {
        dispatch('read')
      })
    },
    insert({ commit, dispatch, state }) {
      axios.admin
        .post('cms/campaign-links', {
          name: state.campaign.name,
          url: state.campaign.url,
          redirect_url: state.campaign.redirect_url,
          source: state.campaign.source,
          medium: state.campaign.medium,
        })
        .then(() => {
          commit('setDialog', false)
          dispatch('read')
        })
    }
  },

  getters: {}
}
